import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { UnidEntityCreateProvider } from './context/unid-entity-create-context';
import { UnidEntityCreateComponent } from './unid-entity-create-component';

export function UnidEntityCreateFactory() {
    return (
        <BaseLayoutFactory urlBeforeAction="/unidades-entidade">
            <UnidEntityCreateProvider>
                <UnidEntityCreateComponent />
            </UnidEntityCreateProvider>
        </BaseLayoutFactory>
    );
}
